
<form [formGroup]="vendorSettingForm">
  <div class="vendor-form">
    <div class="input-container">
      <label for="" class="input-container_label">Lead Days <span class="input-tooltip" [matTooltip]="'The estimated days it takes from placing an order till receiving it'"></span> </label>
      <input
        type="number"
        class="input-container_input"
        formControlName="leadDays"
        min="0"
      />
    </div>

    <div class="input-container">
        <label for="" class="input-container_label">Purchase Days <span class="input-tooltip" [matTooltip]="'The number of days to purchase to meet sales demand'"></span> </label>
        <input
          type="number"
          class="input-container_input"
          formControlName="purchaseDays"
          min="0"
        />
    </div>

    <div class="input-container">
        <label for="" class="input-container_label">Safety Stock <span class="input-tooltip" [matTooltip]="'The additional days of stock to store for safety reasons'"></span> </label>
        <input
          type="number"
          class="input-container_input"
          formControlName="safetyStock"
          min="0"
        />
    </div>
  </div>
  <div class="form-action">
    <app-button [buttonStyle]="'underline'" (click)="cancel()">Cancel</app-button>
    <app-button (click)="save()" [spin]="spin">Save</app-button>
  </div>
</form>
